import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReporteGastoService } from '@app/core';

@Component({
  selector: 'app-gasto',
  templateUrl: './gasto.component.html',
  styleUrls: ['./gasto.component.css']
})
export class GastoComponent implements OnInit {
  buscarForm: FormGroup;
  existencia: any;
  isLoading = false;
  totalSum = 0;
  constructor(
    private formBuilder: FormBuilder,
    private gastoService: ReporteGastoService
  ) {}

  ngOnInit() {
    this.createForm();
    this.listGasto();
  }

  public calculateTotal() {
    return this.existencia.reduce(
      (accum: any, curr: any) => accum + curr.monto,
      0
    );
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      inicio: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      fin: [new Date().toISOString().substring(0, 10), [Validators.required]]
    });
  }
  listGasto() {
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    // alert(mes);
    const data2 = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia
      // fecha_inicio: '2019/09/08',
      // fecha_final: '2019/12/08'
    };
    this.gastoService.gastoReporte(data2).subscribe(
      data => {
        //   console.log(data);
        this.existencia = data;
        this.totalSum = this.calculateTotal();
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia() {
    const data = {
      fecha_inicio: this.buscarForm.value.inicio,
      fecha_final: this.buscarForm.value.fin
    };
    // console.log(data);
    this.gastoService.gastoReporte(data).subscribe(
      data2 => {
        //   console.log(data2);
        this.existencia = data2;
        this.totalSum = this.calculateTotal();
      },
      error1 => {
        console.log(error1);
      }
    );
  }
}
